/**
 * @flow
 * @relayHash a4253cae00c49de3da90d0c0c023c0bb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BillingStatus = "PAYMENT_ISSUE" | "PLAN_ACTIVE" | "TRIAL_ACTIVE" | "TRIAL_EXPIRED_NO_PAYMENT";
export type UpdateBillingPaymentInput = {|
  stripeToken: string
|};
export type UpdateBillingPaymentMutationVariables = {|
  input: UpdateBillingPaymentInput
|};
export type UpdateBillingPaymentMutationResponse = {|
  +updateBillingPayment: {|
    +billingDetails: {|
      +id: string,
      +status: BillingStatus,
      +planId: string,
      +subscriptionId: string,
      +productName: string,
      +planName: string,
      +planDescription: string,
      +planInterval: string,
      +planCostUSD: number,
      +totalSeats: number,
      +active: boolean,
      +trialActive: boolean,
      +trialDaysRemaining: number,
      +fullName: string,
      +cardType: ?string,
      +cardLast4: ?string,
      +cardExpMonth: ?number,
      +cardExpYear: ?number,
      +cardAddressStatus: ?string,
      +cardZipStatus: ?string,
      +cardCVCStatus: ?string,
      +addressLine1: string,
      +addressLine2: string,
      +city: string,
      +state: string,
      +zip: string,
      +country: string,
    |}
  |}
|};
export type UpdateBillingPaymentMutation = {|
  variables: UpdateBillingPaymentMutationVariables,
  response: UpdateBillingPaymentMutationResponse,
|};
*/


/*
mutation UpdateBillingPaymentMutation(
  $input: UpdateBillingPaymentInput!
) {
  updateBillingPayment(input: $input) {
    billingDetails {
      id
      status
      planId
      subscriptionId
      productName
      planName
      planDescription
      planInterval
      planCostUSD
      totalSeats
      active
      trialActive
      trialDaysRemaining
      fullName
      cardType
      cardLast4
      cardExpMonth
      cardExpYear
      cardAddressStatus
      cardZipStatus
      cardCVCStatus
      addressLine1
      addressLine2
      city
      state
      zip
      country
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBillingPaymentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBillingPayment",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateBillingPaymentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "billingDetails",
        "storageKey": null,
        "args": null,
        "concreteType": "BillingDetails",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "planId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "subscriptionId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "productName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "planName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "planDescription",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "planInterval",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "planCostUSD",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalSeats",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "active",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "trialActive",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "trialDaysRemaining",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fullName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cardType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cardLast4",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cardExpMonth",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cardExpYear",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cardAddressStatus",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cardZipStatus",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cardCVCStatus",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine1",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine2",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "zip",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "country",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateBillingPaymentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateBillingPaymentMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateBillingPaymentMutation",
    "id": null,
    "text": "mutation UpdateBillingPaymentMutation(\n  $input: UpdateBillingPaymentInput!\n) {\n  updateBillingPayment(input: $input) {\n    billingDetails {\n      id\n      status\n      planId\n      subscriptionId\n      productName\n      planName\n      planDescription\n      planInterval\n      planCostUSD\n      totalSeats\n      active\n      trialActive\n      trialDaysRemaining\n      fullName\n      cardType\n      cardLast4\n      cardExpMonth\n      cardExpYear\n      cardAddressStatus\n      cardZipStatus\n      cardCVCStatus\n      addressLine1\n      addressLine2\n      city\n      state\n      zip\n      country\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2ce12c8a517fbe7ebd504da2359475ae';
module.exports = node;
